import { render, staticRenderFns } from "./slot-machine.vue?vue&type=template&id=60689759&scoped=true&"
import script from "./slot-machine.vue?vue&type=script&lang=js&"
export * from "./slot-machine.vue?vue&type=script&lang=js&"
import style0 from "./slot-machine.vue?vue&type=style&index=0&id=60689759&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60689759",
  null
  
)

export default component.exports